import React from "react";
import ReactDom from "react-dom"; 
import "./modalToggle.css";
import ZmodalCloser from "./images/modal-closer.png";
import ZmodalTop from "./images/modal-top.png";
import ZmodalBottom from "./images/modal-bott.png";
import PrintAlien from '../../images/print_lg/ealien_lg.jpg';

export default function PrintCdModal(props) {
  const cdModalState = props.toggle
  const action = props.action

  return ReactDom.createPortal (
    <>
    <div className={`z-container ${cdModalState ? 'active' : ''}`}>
      <div className="z-modal">
        <div className="z-modal-closer">
          <a className="close" onClick={action} href="#">
            <img src={ZmodalCloser} alt="Close modal window" />
          </a>
        </div>
        <div className="z-modal-header">
          <img alt="" src={ZmodalTop} />
        </div>
        <div className="z-modal-body">
          <img className="img-fluid" alt="Conceptual Illustration, World Satire" src={PrintAlien} />
        </div>
        <div className="z-modal-footer">
          <img alt="" src={ZmodalBottom} />
        </div>
      </div>
    </div>
    </>,
    document.getElementById('modal-root')
  );
}
